module.exports = __webpack_public_path__ + "static/media/logoLine.a0cf8a29.webp";